(() => {
  if (window.tavProductSellingBound) return;
  window.tavProductSellingBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-tav-open-specs]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!(target instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    target.open = true;
    target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    target.querySelector('summary')?.focus({ preventScroll: true });
  });
})();
